module.exports = __webpack_public_path__ + "img/logo3.a1918669.svg";